<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>


<div *ngIf="!accessdenied" class="row" style="margin-bottom: 15px;">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">Man-days Summary</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <app-services-mandays-summary></app-services-mandays-summary>
    </div>
</div>
<div *ngIf="!accessdenied" class="row" style="margin-bottom: 15px;">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">All service delivery requests</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <div class="col-md-12 col-sm-12 ">
            <div *ngIf="!isLoading" class="row" style="margin-bottom:10px">
                <div class="col-xl-3 col-md-6 col-xs-6 col-sm-6" *ngFor="let status of sdrStatus " style="margin-bottom: 10px;">
                    <a (click)="applyStatusFilter(status.code)" [ngStyle]="{'background-color': status.isActive ? status.active_background_color : status.inactive_background_color, 'color': status.isActive ? status.active_color : status.inactive_color, 'border-color': status.inactive_color }" style="width: 100%; font-size: 13px; height: 35px; margin-right: 20px; font-weight: inherit; color: #00A6B6;" class="btn btn-default">
                        {{status.name}}
                    </a>
                </div>

            </div>
            <div class="row">
                <div *ngIf="isLoading" class="col-xl-12" style="margin-bottom:20px">
                    <div style="text-align: right" class="clearfix">
                        <div class="spinner-border float-right" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isLoading" class="form-group col-md-12 col-sm-12 col-xs-12 " style="margin-bottom:20px">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                        <label for="floatingInputValueSubject">Search for service delivery requests</label>
                    </div>
                </div>

            </div>

            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                    <!-- ID Column -->
                    <ng-container matColumnDef="sdr">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Service delivery request </th>
                        <td style="max-width:300px !important" mat-cell *matCellDef="let row">

                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px; padding-top: 10px;">
                                <small>
                                    <span *ngIf="row.status == 'Confirmation to Start the Work'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status == 'Completion Confirmation'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status == 'New'" style="background-color: blue; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status == 'In Progress'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status == 'Planned'" style="background-color: orange; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status != 'Confirmation to Start the Work' && row.status != 'Completion Confirmation' && row.status != 'New' && row.status != 'In Progress' && row.status != 'Planned'" style="background-color: grey; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>

                                    <br /><br />
                                    <b>{{row.sdrNumber}} </b> - {{row.type}}

                                </small>
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12" style="width:80%;padding-bottom:10px">
                                {{splitText(row.description)}}
                                <br />
                                <span style="opacity:.5" class="feed-time-date">{{row.createdDate | date: 'medium'}}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Progress Column -->
                    <!--<ng-container matColumnDef="respby">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsible by </th>
              <td mat-cell *matCellDef="let row"> {{row.responsibleBy}} </td>
            </ng-container>-->
                    <!-- Name Column -->
                    <ng-container matColumnDef="addby">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Added by </th>
                        <td mat-cell *matCellDef="let row"> {{row.addedBy}} </td>
                    </ng-container>


                    <ng-container matColumnDef="mandays">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Man-days </th>
                        <td mat-cell *matCellDef="let row"> {{row.mandays}} </td>
                    </ng-container>

                    <!--<ng-container matColumnDef="startdate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Start date </th>
              <td mat-cell *matCellDef="let row"> {{row.startDate | date:'medium'}} </td>
            </ng-container>

            <ng-container matColumnDef="enddate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> End date </th>
              <td mat-cell *matCellDef="let row"> {{row.endDate | date:'medium'}} </td>
            </ng-container>-->

                    <ng-container matColumnDef="lastmodifieddate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last modified date </th>
                        <td mat-cell *matCellDef="let row"> {{row.lastModifiedDate | date:'medium'}} </td>
                    </ng-container>-->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr class="table_row" mat-row (click)="clickedRows(row)" *matRowDef="let row; columns: displayedColumns;"></tr>



                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">{{loadingMessage}}</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[ 25, 50, 100]" aria-label="Select page of users"></mat-paginator>
            </div>

        </div>

    </div>
</div>
